import {defineSlotRecipe} from '@chakra-ui/react3'

const sameCombos = [
    ['default', '3'],
    ['condensed', '3'],
    ['default', '5'],
    ['default', '6'],
    ['condensed', '6']
]

const sameFourCombos = [
    ['default', '4'],
    ['condensed', '4']
]

export const cardsSlotRecipe = defineSlotRecipe({
    className: 'cards',
    slots: ['moduleContainer', 'cards', 'card', 'iconText', 'headline', 'cta', 'copy'],

    base: {
        moduleContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'spacing-40', s: 'spacing-80'}
        },
        cards: {
            gap: {base: 'spacing-8', s: 'spacing-16'},
            flexWrap: 'wrap',
            flexDirection: {base: 'column', s: 'row'},
            alignItems: 'stretch'
        },
        card: {
            backgroundColor: 'var(--module-surface-bg-color)',
            color: 'text.primary',
            transition: 'transform 0.2s ease',
            borderRadius: 's'
        },
        iconText: {
            gap: 'spacing-24',
            flexDirection: 'column',
            _icon: {
                width: '6',
                height: '6'
            }
        },
        copy: {
            color: 'text.primary',
            textAlign: 'left'
        }
    },

    variants: {
        variant: {
            default: {
                card: {
                    flexDirection: 'column',
                    padding: 'spacing-40',
                    alignItems: 'start'
                },
                _focusVisible: {padding: 'spacing-40'},

                headline: {display: 'block'},
                copy: {paddingTop: 'spacing-16'}
            },
            condensed: {
                card: {
                    flexDirection: {base: 'row', s: 'column'},
                    padding: {base: 'spacing-20', s: 'spacing-32'},
                    gap: {base: 'spacing-16', s: 'unset'},
                    alignItems: {base: 'center', s: 'start'},
                    justifyContent: {base: 'start', s: 'space-between'}
                },
                _focusVisible: {padding: {base: 'spacing-20', s: 'spacing-32'}},
                headline: {display: 'none'},
                copy: {paddingTop: {base: 0, s: 'spacing-16'}},
                cta: {display: 'none'}
            }
        }
    },

    compoundVariants: [
        ...sameCombos.map(([variant, count]) => ({
            variant,
            count,
            css: {
                card: {
                    minWidth: {
                        base: '100%',
                        s: 'calc((100% - (var(--leap-spacing-spacing-16) * 2)) / 3)'
                    },
                    flex: '1 1 0'
                }
            }
        })),
        ...sameFourCombos.map(([variant, count]) => ({
            variant,
            count,
            css: {
                card: {
                    minWidth: {
                        base: '100%',
                        s: 'calc((100% - (var(--leap-spacing-spacing-16) * 3)) / 4)'
                    }
                },
                cards: {flexWrap: 'nowrap'}
            }
        })),
        {
            variant: 'condensed',
            count: '5',
            css: {
                card: {
                    minWidth: {
                        base: '100%',
                        s: 'calc((100% - (var(--leap-spacing-spacing-16) * 4)) / 5)'
                    }
                },
                cards: {flexWrap: 'nowrap'}
            }
        }
    ],

    defaultVariants: {variant: 'default', count: '3'}
})
